"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetError_1 = require("../Error/WidgetError");
const PluginBase_1 = require("./PluginBase");
/**
 * Plugin definition base.
 */
class PluginDefinition {
    /**
     * Constructs plugin definition.
     *
     * @param {*} definition
     */
    constructor(definition) {
        /**
         * The application priority of the plugin.
         */
        this.priority = 0;
        if (!definition.class) {
            throw new WidgetError_1.default(`Class is required for plugin definition.`);
        }
        if (!definition.id) {
            throw new WidgetError_1.default(`Id is required for plugin definition.`);
        }
        if (!(definition.class.prototype instanceof PluginBase_1.default)) {
            throw new WidgetError_1.default(`Plugin '${definition.id}' does not implement PluginBase.`);
        }
        this.id = definition.id;
        this.classReference = definition.class;
        this.priority = definition.priority || 0;
        this.rawDefinition = definition;
    }
    /**
     * Gets the type ID of the plugin.
     *
     * @return {string}
     */
    static getType() {
        return "plugin";
    }
    /**
     * Gets all the definitions data.
     *
     * @return {*}
     */
    getAll() {
        return this.rawDefinition;
    }
    /**
     * Gets the id of the definition.
     *
     * @return {string}
     */
    getId() {
        return this.id;
    }
    /**
     * Gets the class reference.
     *
     * @return {typeof PluginBase}
     */
    getClass() {
        return this.classReference;
    }
    /**
     * Gets the priority of the plugin.
     *
     * @return {number}
     */
    getPriority() {
        return this.priority;
    }
}
exports.default = PluginDefinition;
